// @ts-nocheck
import { Link } from "@tanstack/react-router";
import { Building2, CalendarDays, CircleUserRound, Cog, ListTodo, MessagesSquare, Route, Timer, Users } from "lucide-react";
import ChatsWatcher from "./Chat/ChatsWatcher";
import { useEffect, useState } from "react";
import getAuth from "../msalAuth";

function Nav() {
  const [userID, setUserID] = useState();
  const [userType, setUserType] = useState()
  useEffect(() => {
    const auth = getAuth();
    if (auth) setUserID(auth.id);
  }, []);
  return (
    <div className="dock z-10 bg-accent text-white dock-md">
      <Link to="/visits">
        <Route className="size-4" />
        <span className="dock-label text-xs">Visits</span>
      </Link>
      <Link to="/tasks">
        {/* <ListTodo className="size-4" /> */}
        <Building2 className="size-4" />
        <span className="dock-label text-xs text-center">Locations</span>
      </Link>
      <Link to="/clients">
        <Users className="size-4" />
        <span className="dock-label text-xs">Clients</span>
      </Link>

      {/* {userType == "H.C" && ( */}
      <Link to="/adhoc">
        <Timer className="size-4" />
        <span className="dock-label text-xs">AdHoc</span>
      </Link>
      {/* )} */}
      {/* <ChatsWatcher /> */}
      {/* <Link to="/chats"> */}
      <a
        href="https://chat.theehgroup.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        <MessagesSquare className="size-4" />
        <span className="dock-label text-xs">Chat</span>
      </a>
      {/* </Link> */}
      <Link to="/me">
        {/* <CalendarDays /> */}
        <CircleUserRound className="size-4" />
        <span className="dock-label text-xs">Me</span>
      </Link>
      <Link to="/settings">
        <Cog className="size-4" />
        <span className="dock-label text-xs">Settings</span>
      </Link>
    </div>
  );
}

export default Nav;
